import { gql } from '@apollo/client';

export const ALL_SERVICE_PROVIDER_ACTIVITIES = gql`
  query AllServiceProviderActivities($input: ExportArgs) {
    activities: allServiceProviderActivities(input: $input) {
      id
      name
      description
    }
  }
`;
